import styled from "styled-components";
import CloseImg from "@/assets/svg/close.svg";
import { useContractWrite } from 'wagmi'
import { ReactSVG } from "react-svg";
import { useEffect, useState } from "react";
import { ethers } from "ethers";
import { arbitrumGoerli } from 'wagmi/chains'
import { jungleAbi, JungleCA } from '@/utils/abi'
import TransferConfimModal from "@/components/TransferConfimModal/Modal";
import { useToastContext } from "@/contexts/ToastContext";
export default function Transfer({ handleClose, jusdBalance, transferError, successCb}) {
  
  const [num, setNum] = useState('')
  const [isOpen, setIsOpen] = useState(false);  
  const { showToast } = useToastContext();

  const config = {
    mode: 'recklesslyUnprepared',
    address: JungleCA,
    abi: jungleAbi,
    functionName: 'moveToLiquid',
    args: [0, ethers.utils.parseUnits(!isNaN(num) && num || '0.0', 18)],
    chainId: arbitrumGoerli.id,
  }
  
  let { data:data2, write:write2, writeAsync } = useContractWrite(config)

  const fuck = async()=>{
    try {
      const fucker = await writeAsync()
      const waitData = await fucker.wait()
      if(waitData?.status === 1){
         showToast({
          dir:'center',
          type:'success',
          text:`${(+num).toFixed(2)} JUSD Transfer!`
        })
        successCb()
      }      
    } catch (error) {
      console.log('err', error);
      successCb()
    }
  }

  const handleTransfer = ()=>{
    if(+num > +jusdBalance){
      return showToast({
        dir:'top',
        type:'error',
        text:`Not Enough Balance`
      })
    }
    fuck()
    setIsOpen(true)
  }
  
  const toMax = ()=>{
    setNum(`${jusdBalance}`)
  }
  const handleChange = (e)=>{
    let val = e.target.value
    if(val.length > 18){
      val = val.slice(0, 18)
    }
    setNum(val)
  }
  
  return (
    <>
      <Modal>
        <div className="close" onClick={handleClose}>
          <ReactSVG src={CloseImg} />          
        </div>
        <div className="content">
          <div className="title">Transfer</div>
          <div className="transfer-direction1">
            <span>From</span>
            <span>To</span>
          </div>
          <div className="transfer-direction2">
            <span>Soild Account</span>
            <span>Debt Book1</span>
          </div>
          <div className="line"></div>
          <div className="input">
            <div className="input-title">Amount</div>
              <div className="field"> 
                <input className="input-comp" type="number" value={num} placeholder="0.0" onChange={handleChange}/>
                <div className="r">  
                  <div className="max" onClick={toMax}>MAX</div>                
                  <div className="token">
                    <span>JUSD</span>
                  </div>                  
                </div>
              </div>
              <div className="ava">Available:${jusdBalance} JUSD</div>
          </div>          
          <div onClick={handleTransfer} className="stake-btn">Transfer</div>
        </div>
      </Modal>
      <TransferConfimModal handleClose={() => setIsOpen(false)} isOpen={isOpen} borrowObj={num}/>
    </>
  );
}

const Modal = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  .close {
    position: absolute;
    right: 35px;
    top: 40px;
    cursor: pointer;
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 36px;

    .title {
      align-self: flex-start;
      padding-bottom:24px;
      font-weight: 600;
      font-size: 24px;
      line-height: 34px;
      color: #32DE86;
    }

    .transfer-direction1{
      width: 100%;
      display: flex;
      justify-content: space-between;
      color: rgba(255, 255, 255, 0.6);
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;      
    }
    .transfer-direction2{
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding-top: 7px;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      color: #fff;
      
    }
    .line{      
      height:1px;   
      width:100%;
      background: rgba(255, 255, 255, 0.1);
      margin-top: 23px;
    }
    .input {
      width: 100%;
      box-sizing: border-box;
      padding: 14px 0 25px;         
      .input-title{
        font-size: 14px;
        line-height: 20px;
        color: rgba(255, 255, 255, 0.5);
        padding-bottom:8px;
      }
      .field{
        background: rgba(255, 255, 255, 0.1);
        border-radius: 8px;
        padding: 0 14px 0 10px;
        height: 77px;
        line-height: 77px;
        font-size: 18px;
      }
      .ava{
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;        
        color: rgba(255, 255, 255, 0.6);
        padding-top: 8px;
      }
    }    
    
    .stake-btn{
      width: 100%;
      box-sizing: border-box;
      height: 44px;
      line-height: 44px;
      background: #32DE86;
      border-radius: 8px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      cursor: pointer;
      font-size: 16px;
      &:hover{
        background:#239B5E; 
      }
    }
    .field {
      display: flex;
      justify-content: space-between;
      .max{
        width: 62px;
        height: 29px;
        line-height: 29px;
        text-align: center;
        border: 1px solid #32DE86;
        color: #32DE86;
        box-sizing: border-box;
        font-weight: 400;
        font-size: 16px;
        border-radius:8px;
        margin-right: 9px;
        cursor: pointer;
      }
      .token{
        display: flex;
        align-items: center;
        color: #fff;
      }
      .r{
        display: flex;
      }
      
      .input-comp {
        background: transparent;
        outline: 0;
        border: 0;
        color: #fff;
        font-weight: 400;
        font-size: 22px;
        max-width: 230px;
        line-height: 38px;        
      }      
      .r{
        display: flex;
        align-items: center;
      }
    }
    
  }
`;
